import { Box, SxProps, Typography } from '@mui/material';

export const Label = ({ text, sx = {} }: { text: string; sx?: SxProps }) => {
  return (
    <Box sx={{ ...styles.root, ...sx }}>
      <Typography variant="caption1Bold" sx={styles.text}>
        {text}
      </Typography>
    </Box>
  );
};

const styles = {
  root: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: 1,
    backgroundColor: 'secondary.main',
    color: 'white',
    px: 0.5,
    py: 0.25,
  },
  text: {
    textTransform: 'uppercase',
    color: 'text.contrast',
  },
};
